import { useEffect, useState } from 'react'
import cx from 'classnames'
import Styles from './BottomButtons.module.scss'
import { focusModeSet } from 'redux/actions/focusMode'
import store from 'redux/store'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { Help } from 'blaze-ui/icons/16'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { HelpDropdown } from 'blaze-components/TopBar/HelpDropdown/HelpDropdown'
import { REACT_APP_DISABLE_TRACKING } from 'env'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardType } from 'components/Wizards/schemas/Types'

export const BottomButtons = ({
  videoTutorialType,
  isSaveFooterActive = false,
}: {
  videoTutorialType?: WizardType
  isSaveFooterActive?: boolean
}) => {
  const currentArticleId = useCurrentArticleId()

  useEffect(() => {
    const onEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        store.dispatch(focusModeSet({ showFocusMode: false, manual: false }))
      }
    }
    document.body.addEventListener('keydown', onEscape)
    return () => document.body.removeEventListener('keydown', onEscape)
  }, [])

  const trigger = (
    <IconButton rounded aria-label="Help" size="lg" useChildClass variant="primary" ignoreHover icon={Help} />
  )

  return (
    <div className={cx(Styles.bottomContainer, { [Styles.withSaveFooter]: isSaveFooterActive })}>
      <div className={Styles.bottomButtons}>
        {!currentArticleId && (
          <HelpDropdown
            trigger={trigger}
            allowOnboarding={false}
            placement="top-start"
            videoTutorialType={videoTutorialType}
          />
        )}
      </div>
    </div>
  )
}

const useIsFullscreenModalOpen = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const checkFullscreenModal = () => {
      setIsOpen(!!document.querySelector('[class*="wrapper"][class*="fullscreen"]'))
    }

    const observer = new MutationObserver(checkFullscreenModal)
    observer.observe(document.body, { childList: true, subtree: true })
    checkFullscreenModal()

    return () => observer.disconnect()
  }, [])

  return isOpen
}

const useIsSaveFooterActive = () => {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const checkSaveFooter = () => {
      setIsActive(!!document.querySelector('[data-save-footer-active]'))
    }

    const observer = new MutationObserver(checkSaveFooter)
    observer.observe(document.body, { childList: true, subtree: true })
    checkSaveFooter()

    return () => observer.disconnect()
  }, [])

  return isActive
}

export const BottomButtonsContainer = () => {
  const { isMobile } = useResponsiveDesign()
  const isFullscreenModalOpen = useIsFullscreenModalOpen()
  const isSaveFooterActive = useIsSaveFooterActive()

  if (REACT_APP_DISABLE_TRACKING) return null
  if (isMobile) return null
  if (isFullscreenModalOpen) return null

  return <BottomButtons isSaveFooterActive={isSaveFooterActive} />
}
